define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Mendaftarkan pengguna lain",

    'incrowd_stats.num_responders': "{{num}} Tenaga Ahli Profesional Layanan Kesehatan",
    'incrowd_stats.num_answers': "{{num}} Pertanyaan yang Dijawab",
    'incrowd_stats.time_to_complete': "{{num}} Menit untuk Menyelesaikan Survei Rata-rata",

    // INCROWD
    'incrowd.about': "Tentang",
    'incrowd.contact': "Kontak",
    'incrowd.press': "Pers",
    'incrowd.careers': "Karir",
    'incrowd.terms': "Syarat-syarat",
    'incrowd.t_and_c': "Syarat-syarat dan Ketentuan",
    'incrowd.faq': "Pertanyaan Umum",
    'incrowd.privacy': "Privasi",
    'incrowd.copyright': "{{year}} InCrowd Inc, Hak Cipta Dilindungi",
    'incrowd.blog': "Blog",
    'incrowd.support': "Dukungan",
    'incrowd.info.ios': "Apakah Anda tahu bahwa para dokter di jaringan InCrowd kini dapat mengirimkan pertanyaan secara langsung ke para kolega mereka? Cobalah sekarang menggunakan <App iOS InCrowd>!",
    'incrowd.refer': "Suka mengisi survei-survei kami? <Referensikan seorang teman> hari ini untuk bergabung dengan orang banyak di tempat kami dan Anda berdua akan memperoleh 10 USD (atau jumlah yang sama). Begitu kolega Anda menjawab sebuah survei, mereka akan menerima bonus!",


    // GET STARTED (step 0)
    'getstarted.encourage.title': "Survei Mikro,",
    'getstarted.encourage.title.two': "Pengaruh Besar-besaran",
    'getstarted.encourage.subtitle': "Bergabunglah dengan ribuan profesional medis yang memenuhi syarat, yang akan memengaruhi pengembangan produk baru dan perawatan pasien melalui survei mikro sederhana, dan kami juga akan membayar Anda!",
    'getstarted.encourage.redirect_to_solutions': "Bukan seorang praktisi medis tetapi ingin mempelajari lebih lanjut tentang InCrowd?",
    'getstarted.actions.title': "Apakah Anda seorang profesional medis yang memenuhi syarat?",
    'getstarted.actions.subtitle': "Mendaftarlah hari ini dan mulai dapatkan uang untuk menjawab survei mikro yang berfokus pada layanan kesehatan",
    'getstarted.button.continue': "Cara Memulai",
    'getstarted.referral': "Mendaftarlah untuk mendapatkan uang dari survei dan bonus referral Anda dari %{{referrerName}}",
    'getstarted.register_with.register_with': "Daftar dengan",
    'getstarted.register_with.email': "Atau dengan email Anda",

    'details.need_info_description': "Kami membutuhkan beberapa perincian dari Anda untuk menyiapkan akun Anda.",
    'details.profile_details': "Perincian Profil",
    'details.address_information': "Informasi Alamat",
    'details.professional_info': "Informasi Profesional",
    'details.heading.finally': "…dan akhirnya",
    'details.how_receive_surveys': "Dengan cara bagaimana Anda ingin menerima survei?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Dasar-dasar",
    'professionchoice.encourage.subtitle': "Beri tahu kami <di sini> untuk memastikan bahwa Anda akan diberi tahu bila kami menambahkan profesi Anda.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Apa profesi Anda?",
    'authentication.encourage.subtitle': "InCrowd perlu memeriksa identitas Anda, tetapi kami tidak akan pernah mengungkapkan atau mendistribusikan informasi pribadi Anda kepada pihak ketiga.",
    'authentication.actions.select_notifications': "Pilih bagaimana Anda ingin menerima survei dari kami",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Silakan tunggu sementara kami memvalidasi informasi Anda",
    'validation.please_answer': "Silakan jawab pertanyaan berikut untuk membantu kami memvalidasi data pribadi Anda",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Konfirmasi",
    'confirmation.validation_success.subtitle': "Pendaftaran Anda selesai, selamat datang di InCrowd! Anda akan menerima konfirmasi segera melalui email dan/atau pesan teks. Terima kasih telah bergabung!",
    'confirmation.validation_error.title': "Informasi Tambahan Diperlukan",
    'confirmation.validation_error.subtitle': "Maaf, %{userFirstName}, kami mengalami masalah saat memvalidasi data pribadi Anda.",
    'confirmation.actions_title': "Bagaimana selanjutnya?",
    'confirmation.go_to_your_profile': "Buka profil Anda",
    'confirmation.validation_success.actions_subtitle': "Anda akan mulai menerima 3 - 5 menit survei mikro kami dalam beberapa hari melalui email atau pesan teks. Belum memilih untuk menerima survei melalui pesan teks? Anda dapat mengubah pengaturan komunikasi Anda setiap saat dari profil InCrowd Anda.",
    'confirmation.validation_error.actions_subtitle': "Silakan menggunakan obrolan sembul di sebelah kanan bawah dari layar untuk berbicara dengan anggota tim InCrowd dan menyampaikan masalah yang belum diselesaikan.",
    'confirmation.referral.info.1': "Dalam %{payoutBusinessDays} hari kerja sejak Anda menyelesaikan survei ke-2, Anda dan orang yang telah merujuk Anda, <masing-masing akan menerima %{currency}%{referralBonusAmount}>. %{currency}%{referralBonusAmount} ini akan ditambahkan ke akun imbalan Anda. Anda bisa masuk ke <profil> Anda kapan saja untuk memperbarui preferensi, meninjau imbalan Anda, atau mengakses survei terbuka mana saja yang undangannya Anda terima.",
    'confirmation.referral.info.2': "Punya pertanyaan? <Mengobrollah dengan kami>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Apakah Anda memenuhi syarat?",
    'regftr.markets.accepting': "Jawaban yang saat ini sedang diterima InCrowd:",
    'regftr.peers.title': "Rekan-rekan",
    'regftr.peers.subtitle': "Bandingkan tanggapan Anda dengan jawaban dari rekan-rekan Anda dan pelajari dari balasan mereka.",
    'regftr.invites.title': "Undangan",
    'regftr.invites.subtitle': "Dapatkan undangan survei baru melalui surel atau pada ponsel Anda untuk memaksimalkan perolehan Anda.",
    'regftr.earnings.title': "Perolehan",
    'regftr.earnings.subtitle': "Kelola dan ikuti perkembangan perolehan Anda serta informasi pembayaran.",
    'regftr.stats.title': "Data Statistik",
    'regftr.stats.subtitle': "Akses papan petunjuk beserta semua informasi survei dan perincian pengguna milik Anda.",

    'contextual_help.sms': "Anda akan menerima pemberitahuan SMS tentang survei mikro yang terbuka. Melalui SMS, Anda dapat mengikuti survei lebih cepat dan mendapatkan imbalan lebih besar. Informasi Anda terjaga kerahasiaannya dan hanya digunakan untuk undangan survei.",
    'contextual_help.specialty': "Mohon sertakan hanya spesialisasi yang terkait dengan NPI Anda, beasiswa yang telah Anda selesaikan, atau bidang kedokteran yang berhubungan dengan spesialisasi utama Anda. Jika Anda perlu mengubah spesialisasi Anda di waktu mendatang, silakan hubungi support@incrowdnow.com.",
    // USER
    'user(s)': "Pengguna |||| Para pengguna",
    'user.login': "Masuk",
    'user.logout': "Keluar",
    'user.register': "Mendaftar",
    'user.invitations': "Undangan",
    'user.email': "Surel",
    'user.pass_word': "Kata sandi",
    'user.mobile': "Ponsel",
    'user.mobile.hint': "Mohon masukkan kode negara (+%{phoneCode} untuk %{countryName})",
    'user.title': "Gelar",
    'user.title_with_example': "Gelar (e.g. Dr., Nn., Tn.)",
    'user.first_name': "Nama Depan",
    'user.last_name': "Nama Belakang",
    'user.middle_name': "Nama Tengah",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Seorang Pengguna",
    'user.anonymous_admin': "Pengguna Admin",
    'user.dashboard': "Dasbor",
    'user.profile': "Profil",
    'user.profile.picture.upload': "Unggah foto profil",
    'user.profile.picture.change': "Ubah",
    'user.primary_lang': "Bahasa Utama",
    'user.primary_lang?': "Apakah bahasa utama Anda?",
    'user.survey_langs?': "Anda fasih berbicara bahasa apa saja?",
    'user.notify_email': "Pemberitahuan Melalui Surel",
    'user.notify_mobile': "Pemberitahuan Melalui Ponsel",
    'user.contact_support': "Hubungi Dukungan",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Mohon <hubungi kami>.",
    'user.profession': "Profesi",
    'user.profession?': "Apakah profesi Anda?",
    'user.join_now': "Bergabung Sekarang",
    'user.welcome_back': "Selamat datang kembali!",
    'user.not_a_member?': "Belum Menjadi Anggota?",
    'user.accept_terms': "Menerima Syarat-syarat",
    'user.accept_terms.yes': "Saya menerima <syarat-syarat dan ketentuan>",
    'user.remember_me': "Ingat saya pada perangkat ini",
    'user.time_zone': "Zona Waktu",
    'user.payment.policy': "Setiap kali Anda mencapai %{currency}25 di imbalan Anda akan diberitahu dan dapat memilih dari pilihan pembayaran kami melalui profil InCrowd Anda. Pertanyaan? Hubungi kami melalui jendela obrolan di bawah ini.",
    'user.country.live_work?': "Di negara manakah Anda tinggal dan bekerja?",
    // FORMS
    'form.button.back': "Kembali",
    'form.button.next': "Selanjutnya",
    'form.button.cancel': "Batalkan",
    'form.button.submit': "Kirim",
    'form.button.continue': "Lanjutkan",
    'form.button.close': "Tutup",
    'form.button.go!': "Mulai!",
    'form.button.complete!': "Isi sekarang!",
    'form.button.update': "Perbarui",
    'form.button.finish': "Selesaikan",
    'form.button.search': "Cari",
    'form.button.end': "Akhiri",
    'form.search.no_matches': "Tidak ditemukan",
    'form.confirm_email': "Konfirmasikan Surel",
    'form.confirm_pass_word': "Konfirmasikan Kata Sandi",
    'form.required_fields': "Bidang yang diperlukan",
    'form.nothing_selected': "Tidak ada yang dipilih",
    'form.confirm_field': "Konfirmasikan %{formFieldLabel}",
    'form.choice.n/a': "Tidak Berlaku",
    'form.choice.yes': "Ya",
    'form.choice.no': "Tidak",
    'form.choice.blank_for_all': "Biarkan kosong untuk memilih semuanya",
    'form.choices.select_all': "Pilih semuanya",
    'form.choices.deselect_all': "Kosongkan semua pilihan",
    'form.field.private': "Bidang pribadi",

    // USER ERRORS
    'user.error.dup_email': "Pengguna lain sudah terdaftar dengan alamat surel yang diberikan. <Tetap masuk?>",
    'user.error.dup_sms': "Sudah ada pengguna lain yang terdaftar menggunakan nomor ponsel yang diberikan",
  }
})
